import { CustomIconProps } from './art';

export const ShareProfileIcon = ({
  height,
  width,
}: CustomIconProps): JSX.Element => (
  <svg
    width={width ? width : '32'}
    height={height ? height : '42'}
    viewBox="0 0 32 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#shareProfile)">
      <rect
        y="0.591797"
        width="32"
        height="40"
        rx="2"
        transform="rotate(-0.208199 0 0.591797)"
        fill="white"
      />
      <path
        d="M0.00726749 2.59178C0.00325377 1.48722 0.895425 0.588543 1.99999 0.584529L29.9998 0.482784C31.1044 0.478771 32.003 1.37094 32.0071 2.4755L32.0659 18.6783L0.0661449 18.7946L0.00726749 2.59178Z"
        fill="#259BE9"
      />
      <rect
        x="11"
        y="4.53516"
        width="9.80854"
        height="9.39832"
        rx="2"
        transform="rotate(-0.208199 11 4.53516)"
        fill="#EFEFEF"
      />
      <ellipse cx="16" cy="9.51367" rx="4" ry="3" fill="#FDDA05" />
      <ellipse
        rx="0.500609"
        ry="0.271533"
        transform="matrix(0.998512 0.0545386 -0.060033 0.998196 13.5407 8.81202)"
        fill="#FB9378"
        fillOpacity="0.5"
      />
      <ellipse
        rx="0.500609"
        ry="0.291731"
        transform="matrix(0.998512 0.0545386 -0.060033 0.998196 18.539 8.83218)"
        fill="#FB9378"
        fillOpacity="0.5"
      />
      <path
        d="M16.7116 8.77167C16.7116 8.77167 16.6345 9.18241 16.1805 9.19466C15.7265 9.20692 15.6523 8.80026 15.6523 8.80026"
        stroke="#CFB202"
        strokeWidth="0.1"
        strokeLinecap="round"
      />
      <circle
        cx="15.1497"
        cy="8.64832"
        r="0.15"
        transform="rotate(0.858358 15.1497 8.64832)"
        fill="#666666"
      />
      <circle
        cx="17.3494"
        cy="8.68153"
        r="0.15"
        transform="rotate(0.858358 17.3494 8.68153)"
        fill="#666666"
      />
      <path
        d="M14.2805 5.61619C14.2978 5.47349 14.4172 5.37682 14.5473 5.40026C14.6774 5.4237 14.7688 5.55838 14.7515 5.70108L14.2805 5.61619ZM14.516 5.65863C14.7515 5.70108 14.7515 5.70093 14.7516 5.70078C14.7516 5.70074 14.7516 5.70059 14.7516 5.7005C14.7516 5.70031 14.7516 5.70013 14.7517 5.69995C14.7517 5.69959 14.7517 5.69925 14.7518 5.69893C14.7518 5.69828 14.7519 5.6977 14.752 5.69718C14.7521 5.69615 14.7521 5.69538 14.7522 5.69486C14.7523 5.69381 14.7523 5.69371 14.7522 5.69445C14.7522 5.69598 14.752 5.70058 14.7523 5.70746C14.753 5.7217 14.7555 5.74223 14.7626 5.76452C14.7739 5.80039 14.8021 5.86072 14.9034 5.90794L14.73 6.38937C14.4905 6.27784 14.3683 6.09316 14.3146 5.9237C14.2891 5.84333 14.2803 5.77112 14.2778 5.71829C14.2766 5.69163 14.2769 5.66911 14.2777 5.6519C14.2781 5.64328 14.2786 5.6359 14.2791 5.62993C14.2794 5.62693 14.2796 5.62428 14.2799 5.62199C14.28 5.62084 14.2801 5.61979 14.2802 5.61882C14.2803 5.61833 14.2803 5.61787 14.2804 5.61744C14.2804 5.61722 14.2804 5.617 14.2804 5.6168C14.2804 5.61669 14.2805 5.61654 14.2805 5.61649C14.2805 5.61634 14.2805 5.61619 14.516 5.65863ZM14.9034 5.90794C15.0397 5.97143 15.1294 5.9745 15.2695 6.00069C15.4188 6.02863 15.5792 6.08196 15.743 6.27126L15.404 6.62653C15.3382 6.5505 15.2905 6.53309 15.2041 6.51692C15.1083 6.49901 14.9345 6.48462 14.73 6.38937L14.9034 5.90794ZM15.743 6.27126C16.0396 6.61405 16.0916 7.12529 15.8429 7.43424L15.4832 7.08005C15.5362 7.01422 15.5666 6.8144 15.404 6.62653L15.743 6.27126ZM15.8429 7.43424C15.7488 7.55124 15.6574 7.62349 15.5619 7.66977C15.4783 7.71033 15.3853 7.7302 15.3492 7.74067L15.2153 7.23391C15.2982 7.20992 15.3202 7.20841 15.3595 7.18935C15.387 7.17603 15.4266 7.15044 15.4832 7.08005L15.8429 7.43424Z"
        fill="#FDDA05"
      />
      <path
        d="M16.232 4.51367C16.232 4.51367 15.9757 4.98036 16.0019 5.2864C16.0473 5.81766 17.0341 5.98214 16.9991 6.51367C16.9708 6.94232 16.232 7.51367 16.232 7.51367"
        stroke="#FDDA05"
        strokeWidth="0.5"
        strokeLinecap="round"
      />
      <rect x="2" y="23.5" width="28" height="2" rx="1" fill="#808080" />
      <rect x="2" y="36.5" width="28" height="2" rx="1" fill="#808080" />
      <rect x="2" y="20.5" width="10" height="2" rx="1" fill="#808080" />
      <rect x="2" y="26.5" width="28" height="2" rx="1" fill="#808080" />
      <rect x="2" y="30.5" width="10" height="2" rx="1" fill="#808080" />
      <rect x="2" y="33.5" width="28" height="2" rx="1" fill="#808080" />
      <path
        d="M13.342 15.08V16.5H13.068V15.894H12.424V16.5H12.148V15.08H12.424V15.654H13.068V15.08H13.342ZM13.6722 15.306V15.04H13.9402V15.306H13.6722ZM13.6722 16.5V15.452H13.9402V16.5H13.6722ZM14.266 16.73L14.32 16.492H14.236V16.212H14.468V16.492L14.386 16.73H14.266ZM15.3333 16.5V15.08H15.6093V16.258H16.3333V16.5H15.3333ZM17.0135 16.52C16.9001 16.52 16.8021 16.4953 16.7195 16.446C16.6381 16.3967 16.5748 16.3313 16.5295 16.25C16.4841 16.1673 16.4615 16.078 16.4615 15.982C16.4615 15.8833 16.4835 15.7927 16.5275 15.71C16.5728 15.626 16.6368 15.5593 16.7195 15.51C16.8021 15.4593 16.9008 15.434 17.0155 15.434C17.1301 15.434 17.2281 15.4593 17.3095 15.51C17.3908 15.5593 17.4528 15.6253 17.4955 15.708C17.5395 15.7893 17.5615 15.8773 17.5615 15.972C17.5615 16.0067 17.5595 16.0367 17.5555 16.062H16.7455C16.7521 16.1433 16.7821 16.2073 16.8355 16.254C16.8901 16.3007 16.9528 16.324 17.0235 16.324C17.0768 16.324 17.1268 16.3113 17.1735 16.286C17.2215 16.2593 17.2541 16.2247 17.2715 16.182L17.5015 16.246C17.4628 16.326 17.4008 16.392 17.3155 16.444C17.2301 16.4947 17.1295 16.52 17.0135 16.52ZM16.7395 15.892H17.2875C17.2795 15.8133 17.2495 15.75 17.1975 15.702C17.1468 15.6527 17.0848 15.628 17.0115 15.628C16.9395 15.628 16.8775 15.6527 16.8255 15.702C16.7748 15.75 16.7461 15.8133 16.7395 15.892ZM18.0374 16.5L17.6514 15.452H17.9294L18.1934 16.256L18.4594 15.452H18.7134L18.3294 16.5H18.0374ZM19.3639 16.52C19.2492 16.52 19.1506 16.4953 19.0679 16.446C18.9866 16.3953 18.9239 16.3287 18.8799 16.246C18.8359 16.1633 18.8139 16.074 18.8139 15.978C18.8139 15.8807 18.8359 15.7907 18.8799 15.708C18.9252 15.6253 18.9886 15.5593 19.0699 15.51C19.1526 15.4593 19.2506 15.434 19.3639 15.434C19.4772 15.434 19.5746 15.4593 19.6559 15.51C19.7386 15.5593 19.8019 15.6253 19.8459 15.708C19.8899 15.7907 19.9119 15.8807 19.9119 15.978C19.9119 16.074 19.8899 16.1633 19.8459 16.246C19.8019 16.3287 19.7386 16.3953 19.6559 16.446C19.5746 16.4953 19.4772 16.52 19.3639 16.52ZM19.0899 15.978C19.0899 16.0393 19.1019 16.094 19.1259 16.142C19.1499 16.1887 19.1826 16.2253 19.2239 16.252C19.2652 16.2787 19.3119 16.292 19.3639 16.292C19.4146 16.292 19.4606 16.2787 19.5019 16.252C19.5432 16.224 19.5759 16.1867 19.5999 16.14C19.6252 16.092 19.6379 16.0373 19.6379 15.976C19.6379 15.916 19.6252 15.8627 19.5999 15.816C19.5759 15.768 19.5432 15.7307 19.5019 15.704C19.4606 15.676 19.4146 15.662 19.3639 15.662C19.3119 15.662 19.2652 15.676 19.2239 15.704C19.1826 15.7307 19.1499 15.768 19.1259 15.816C19.1019 15.8627 19.0899 15.9167 19.0899 15.978Z"
        fill="white"
      />
    </g>
    <path
      d="M4 1.5H28V-0.5H4V1.5ZM31 4.5V37.5H33V4.5H31ZM28 40.5H4V42.5H28V40.5ZM1 37.5V4.5H-1V37.5H1ZM4 40.5C2.34315 40.5 1 39.1569 1 37.5H-1C-1 40.2614 1.23858 42.5 4 42.5V40.5ZM31 37.5C31 39.1569 29.6569 40.5 28 40.5V42.5C30.7614 42.5 33 40.2614 33 37.5H31ZM28 1.5C29.6569 1.5 31 2.84315 31 4.5H33C33 1.73858 30.7614 -0.5 28 -0.5V1.5ZM4 -0.5C1.23858 -0.5 -1 1.73858 -1 4.5H1C1 2.84315 2.34315 1.5 4 1.5V-0.5Z"
      fill="#259BE9"
    />
    <defs>
      <clipPath id="shareProfile">
        <path
          d="M0 4.5C0 2.29086 1.79086 0.5 4 0.5H28C30.2091 0.5 32 2.29086 32 4.5V37.5C32 39.7091 30.2091 41.5 28 41.5H4C1.79086 41.5 0 39.7091 0 37.5V4.5Z"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
